<ng-content></ng-content>
@if (isRequired) {
    <span class="text-danger"> *</span>
}